import { render, staticRenderFns } from "./SearchDetail.vue?vue&type=template&id=a96b4768&"
import script from "./SearchDetail.vue?vue&type=script&lang=ts&"
export * from "./SearchDetail.vue?vue&type=script&lang=ts&"
import style0 from "./SearchDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports